import React, { useContext, useEffect, useState } from "react";
import styles from "./index.module.scss";
import { Trans, useTranslation } from "react-i18next";
import {
  Alert,
  Button,
  Card,
  CardContent,
  Grid,
  Snackbar,
} from "@mui/material";
import {
  redirect,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import AppContext from "../../contexts/appContext";
import { SIGN_IN, LOGO_IMG } from "../../constants";
import { _MainURL } from "../../services";
const Auth = () => {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token");
  const success = new URLSearchParams(window.location.search).get("success");
  const session_id = new URLSearchParams(window.location.search).get("session");
  const navigate = useNavigate();
  const [toastMessage, setToastMessage] = useState({ msg: "", type: null });
  const _location = useLocation();
  const {
    state: { auth },
    dispatch,
  } = useContext(AppContext);

  useEffect(() => {
    if (auth.authed) {
      let goto = new URLSearchParams(_location.search).get("redirect") || "/";
      navigate(goto);
    }
    return () => {};
  }, [auth.authed]);

  useEffect(() => {
    if (token && success === "true") {
      dispatch({ type: SIGN_IN, payload: { token: token, session_id: session_id } });
    } else if (token && success === "false") {
      setToastMessage({
        msg: t("approvals.create_messageError"),
        type: "error",
      });
    }
    return () => {};
  }, [token]);

  const handleLogin = () => {
    let goto = new URLSearchParams(_location.search).get("redirect");
    let _url = !!goto
      ? _MainURL+"/v1/auth/sso?redirect=" + goto
      : _MainURL+"/v1/auth/sso";
    window.open(_url, "_self");
  };
  return (
    <div className={styles.authPage}>
      <span className={styles.bg}>
        <img src="../../assets/imgs/bg.jpg" alt="" />
      </span>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={6}>
          <div className={styles.side}>
            <div className={styles.logo}>
              <LOGO_IMG />
            </div>
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={!!toastMessage?.msg}
              autoHideDuration={6000}
              onClose={() => {
                setToastMessage({ msg: "", type: "" });
              }}
            >
              <Alert
                onClose={() => {
                  setToastMessage({ msg: "", type: "" });
                }}
                severity={toastMessage.type === "error" ? "error" : "success"}
                sx={{ width: "100%" }}
              >
                {toastMessage.msg}
              </Alert>
            </Snackbar>
            <Card className={styles.authCard}>
              <CardContent className={styles.authCardContent}>
                <Button
                  id="sign-button"
                  variant="contained"
                  className={styles.signButton}
                  disableElevation
                  type="primary"
                  onClick={handleLogin}
                >
                  <span className="txt">
                    <Trans>auth.login</Trans>
                  </span>
                </Button>
              </CardContent>
            </Card>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Auth;
